const paths = {
  zen: "https://cdn.izettle.com/fonts/zen",
  dingbatz: "https://cdn.izettle.com/fonts/dingbatz_v3120"
};
const fonts = {
  zen: {
    name: "Zen",
    /*
     * `Zent` is temporary and should be removed in the future.
     * It is only here to provide a fallback for if the page hasn't assigned the font the proper name yet.
     */
    fallbacks: ["Zent", "Arial", "sans-serif"],
    formats: ["woff2", "woff"],
    fonts: {
      ppOpenRegular: {
        name: "PayPalOpen-Regular",
        weight: "400",
        file: "https://www.paypalobjects.com/paypal-ui/fonts/PayPalOpen-Regular"
      },
      ppOpenMedium: {
        name: "PayPalOpen-Medium",
        weight: "500",
        file: "https://www.paypalobjects.com/paypal-ui/fonts/PayPalOpen-Regular"
      },
      ppOpenSemiBold: {
        name: "PayPalOpen-SemiBold",
        weight: "500",
        file: "https://www.paypalobjects.com/paypal-ui/fonts/PayPalOpen-Regular"
      },
      ppOpenBold: {
        name: "PayPalOpen-Bold",
        weight: "700",
        file: "https://www.paypalobjects.com/paypal-ui/fonts/PayPalOpen-Bold"
      },
      light: {
        name: "Zen",
        weight: "300",
        file: `${paths.zen}/Zen-Light`
      },
      regular: {
        name: "Zen",
        weight: "400",
        file: `${paths.zen}/Zen-Screen`
      },
      medium: {
        name: "Zen",
        weight: "500",
        file: `${paths.zen}/Zen-Medium`
      },
      semiBold: {
        name: "Zen",
        weight: "500",
        file: `${paths.zen}/Zen-SemiBold`
      },
      bold: {
        name: "Zen",
        weight: "700",
        file: `${paths.zen}/Zen-Bold`
      },
      extraBold: {
        name: "Zen",
        weight: "900",
        file: `${paths.zen}/Zen-ExtraBold`
      }
    }
  },
  dingbatz: {
    name: "Dingbatz",
    fallbacks: [],
    formats: ["woff2", "woff"],
    fonts: {
      light: {
        name: "Dingbatz-Light",
        weight: 300,
        file: `${paths.dingbatz}/Dingbatz-Light`
      },
      regular: {
        name: "Dingbatz-Regular",
        weight: 400,
        file: `${paths.dingbatz}/Dingbatz-Regular`
      }
    }
  }
};

export { fonts };
//# sourceMappingURL=fonts.js.map
